import SupportedCamerasForm from 'app/components/shared/SupportedCamerasForm'
import UnsupportedCameraForm from 'app/components/shared/UnsupportedCameraForm'

window.addEventListener('DOMContentLoaded', function () {
  window.waAdditionalComponents = {
    SupportedCamerasForm,
    UnsupportedCameraForm
  }
})
